/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

// Components.
import {
  Stack,
  Typography,
  Grid,
  Divider,
  Chip
} from '@mui/material';

// Componentes
import Heading from '../components/heading/Heading';
import msgNotificacion from "../scripts/notification";
import Formatter from '../scripts/formatters';
import ImageStack from '../components/custom/ImageStack';

// Redux
import { NAME_PROJECT } from '../redux/constants/index';
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';

// Services
import HomeService from '../services/homeService';

export default function MiPerfil() {
  const dispatch = useDispatch()
  const userLogin = JSON.parse(localStorage.getItem('user'))
  const empleadoSelected = localStorage.getItem('empleadoSelected')
  const [dataPerfil, setDataPerfil] = useState()

  // Calcular años y meses de servicio
  const calcularAniosServicio = (fechaIngreso) => {
    if (!fechaIngreso) return 'N/A'
    
    try {
      const fechaIng = new Date(fechaIngreso)
      const fechaActual = new Date()
      
      // Calcular diferencia en años
      let anios = fechaActual.getFullYear() - fechaIng.getFullYear()
      let meses = fechaActual.getMonth() - fechaIng.getMonth()
      
      // Ajustar si los meses son negativos
      if (meses < 0) {
        anios--
        meses += 12
      }
      
      // Ajustar por días si es necesario
      if (fechaActual.getDate() < fechaIng.getDate()) {
        if (meses === 0) {
          anios--
          meses = 11
        } else {
          meses--
        }
      }
      
      // Formatear el resultado
      if (anios === 0) {
        return meses === 1 ? '1 mes' : `${meses} meses`
      } else if (meses === 0) {
        return anios === 1 ? '1 año' : `${anios} años`
      } else {
        const anioTexto = anios === 1 ? '1 año' : `${anios} años`
        const mesTexto = meses === 1 ? '1 mes' : `${meses} meses`
        return `${anioTexto} y ${mesTexto}`
      }
    } catch (error) {
      console.error('Error al calcular años de servicio:', error)
      return 'N/A'
    }
  }

  const rowsControls = [
    {
      Id: 1,
      Nombre: 'CÓDIGO DE EMPLEADO:',
      Data: dataPerfil?.CodEmpleado,
      Icon: 'bx bxs-user-circle text-white me-2'
    },
    {
      Id: 2,
      Nombre: 'DEPARTAMENTO:',
      Data: dataPerfil?.Area,
      Icon: 'bx bx-building text-white me-2'
    },
    {
      Id: 3,
      Nombre: 'CARGO:',
      Data: dataPerfil?.Cargo,
      Icon: 'bx bx-briefcase text-white me-2'
    },
    {
      Id: 4,
      Nombre: 'SALARIO:',
      Data: `${dataPerfil?.Moneda} ${Formatter.currencyFormatter(dataPerfil?.Salario || 0)}`,
      Icon: 'bx bx-money text-white me-2'
    },
    {
      Id: 5,
      Nombre: 'FECHA DE INGRESO:',
      Data: Formatter.dateFormatter(dataPerfil?.FechaIng),
      Icon: 'bx bx-calendar-check text-white me-2'
    },
    {
      Id: 6,
      Nombre: 'AÑOS DE SERVICIO:',
      Data: calcularAniosServicio(dataPerfil?.FechaIng),
      Icon: 'bx bx-time text-white me-2'
    },
    {
      Id: 7,
      Nombre: 'INSS:',
      Data: dataPerfil?.Inss,
      Icon: 'bx bx-note text-white me-2'
    },
    {
      Id: 8,
      Nombre: 'CORREO ELECTRÓNICO',
      Data: dataPerfil?.Email,
      Icon: 'bx bx-envelope text-white me-2'
    },
    {
      Id: 9,
      Nombre: 'VAC. PENDIENTES:',
      Data: Formatter.currencyFormatter(dataPerfil?.VacPendientes || 0),
      Icon: 'bx bx-calendar-exception text-white me-2'
    },
    {
      Id: 10,
      Nombre: 'CÉDULA DE IDENTIDAD:',
      Data: dataPerfil?.Cedula,
      Icon: 'bx bxs-user-badge text-white me-2'
    },
    {
      Id: 11,
      Nombre: 'NOMBRES Y APELLIDOS:',
      Data: dataPerfil?.Nombres,
      Icon: 'bx bxs-face text-white me-2'
    },
    {
      Id: 12,
      Nombre: 'NACIONALIDAD:',
      Data: 'NICARAGUENSE',
      Icon: 'bx bx-street-view text-white me-2'
    },
    {
      Id: 13,
      Nombre: 'FECHA DE NACIMIENTO:',
      Data: Formatter.dateFormatter(dataPerfil?.FechaNac),
      Icon: 'bx bx-calendar-plus text-white me-2'
    },
    {
      Id: 14,
      Nombre: 'TELEFONO:',
      Data: dataPerfil?.Telefono,
      Icon: 'bx bx-phone text-white me-2'
    },
    {
      Id: 15,
      Nombre: 'DIRECCIÓN DOMICILIAR:',
      Data: dataPerfil?.Direccion,
      Icon: 'bx bx-location-plus text-white me-2'
    },
  ]

  const getPerfilEmpleado = async (data) => {
    try {
      HomeService.getProfileEmployed(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')

            return
          }          

          setTimeout(() => {
            if (response.Codigo === 1) {
              setDataPerfil(response?.Data)
            } else {
              setDataPerfil([])
              msgNotificacion(response?.Mensaje, 'info')
            }
          }, 500)
        })
        .catch((error) => {
          dispatch(showProgress(false));
          msgNotificacion(error, 'error')
        })
    } catch (error) {
      console.error(error)
    }
  }

  let initPage = false
  useEffect(() => {
    document.title = `Mi perfil - ${NAME_PROJECT}`;

    try {
      dispatch(showProgress(true))

      setTimeout(() => {
        if (!initPage) {
          initPage = true

          const data = {
            codEmpleado: empleadoSelected ?? userLogin.CodigoEmpleado
          }

          getPerfilEmpleado(data)
        }

        localStorage.removeItem('empleadoSelected')
        dispatch(showProgress(false))
      }, 1000)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return <div className='App-content overflow-home'>
    <Heading className='mt-0 py-0 w-100 heading justify-content-center'>
      <div className='heading-text text-default'>
        <i className='bx bxs-user-badge me-2'></i>
        <span className='fw-bolder'>FICHA DE EMPLEADO FERNÁNDEZ SERA</span>
      </div>
    </Heading>

    <Grid container spacing={1} paddingLeft={1} paddingRight={1} paddingBottom={1} paddingTop={2} marginLeft={0}>
      <Grid item xs={12} md={8} border={1} paddingRight={1}>
        <Stack display='flex' justifyContent='center' alignItems='flex-start' marginBottom={2}>
          <Divider sx={{ width: '100%' }} className='divi-info'>
            <Chip label="Perfil del Empleado" size="small" color='success' sx={{ border: 1 }} />
          </Divider>
          {
                         rowsControls.map((item) => {
               if (item.Id === 9) {
                 return (
                   <div key={item.Id} className='w-100'>
                     <Typography component='p' paddingY={1} paddingX={1} fontSize={18} display='flex' width='100%' border={1}>
                       <i className={item?.Icon}></i>
                       <span className='me-2'>{item?.Nombre}</span>
                       <span className='text-warning'>{item?.Data}</span>
                     </Typography>
                     <Divider sx={{ width: '100%', marginTop: 1 }} className='divi-info'>
                       <Chip label="Información Personal" size="small" color='info' sx={{ border: 1 }} />
                     </Divider>
                   </div>
                 )
               } else {
                return (
                  <Typography component='p' paddingY={0.5} paddingX={1} fontSize={18} display='flex' key={item.Id} width='100%'>
                    <i className={item?.Icon}></i>
                    <span className='me-2'>{item?.Nombre}</span>
                    <span className='text-warning'>{item?.Data}</span>
                  </Typography>
                )
              }
            })
          }
        </Stack>
      </Grid>
      <Grid item xs={12} md={4} border={1} paddingRight={1}>
        <ImageStack imagen={dataPerfil?.ImagenBase} descrip={`Foto_${dataPerfil?.CodEmpleado}`} titulo='Foto de Perfil' />
      </Grid>
    </Grid>

  </div>
}